module.exports = __webpack_public_path__ + "static/img/major_profile_800x790.f2cb986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_profile_800x790.jpg
// module id = v2NM
// module chunks = 0